import { render, staticRenderFns } from "./OrderItemShipmentDetail.vue?vue&type=template&id=0781b73b&scoped=true"
import script from "./OrderItemShipmentDetail.vue?vue&type=script&lang=js"
export * from "./OrderItemShipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderItemShipmentDetail.vue?vue&type=style&index=0&id=0781b73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0781b73b",
  null
  
)

export default component.exports